import { render, staticRenderFns } from "./ClassForm.vue?vue&type=template&id=548ca26f&"
import script from "./ClassForm.vue?vue&type=script&lang=js&"
export * from "./ClassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports